export default __webpack_public_path__ + "static/media/cat-placeholder.373549be.svg";